import api from "./axios";

export const unifiedSearch = (q) =>
  api.get("/api/search/", { params: { q } });